import React from "react";
import { AddressLink, CopyBtn } from "@/components/primitives";
import { AdaAmount } from "@/components/tx/AdaAmount";
import { _decodeAssetName, truncMid } from "@/lib/format";

// ---------- single UTXO row (used inside FromToList / tx_utxos tab) ----------
export const UtxoRow = ({ row, side }) => {
  const ada = row.amount?.find?.((a) => a.unit === "lovelace")?.quantity || "0";
  const tokens = (row.amount || []).filter((a) => a.unit !== "lovelace");
  return (
    <div
      data-testid={`utxo-row-${side}`}
      className="px-5 py-4 border-b border-primary/10 last:border-b-0 hover:bg-primary/[0.03] transition-colors"
    >
      <div className="grid grid-cols-[minmax(0,1fr)_auto] gap-6 items-start">
        {/* LEFT — address + (input source ref) */}
        <div className="min-w-0 space-y-1.5">
          <div className="flex items-center gap-2 min-w-0">
            <CopyBtn value={row.address} label="address" />
            <AddressLink value={row.address} className="font-mono text-[12px] text-primary text-glow break-all" />
          </div>
          {side === "in" && row.tx_hash ? (
            <div className="flex items-center gap-2 pl-1 min-w-0">
              <CopyBtn value={row.tx_hash} label="src-tx" />
              <span className="font-mono text-[11px] text-muted-foreground/80 break-all">
                {row.tx_hash}
              </span>
              <span className="font-mono text-[11px] text-muted-foreground whitespace-nowrap">
                #{row.output_index ?? 0}
              </span>
            </div>
          ) : null}
        </div>
        {/* RIGHT — ADA amount (compact, no wrapping) */}
        <div className="whitespace-nowrap shrink-0">
          <AdaAmount lovelaceStr={ada} />
        </div>
      </div>
      {tokens.length ? (
        <div className="mt-3 flex flex-wrap gap-1.5 justify-end">
          {tokens.map((t) => {
            const { name } = _decodeAssetName(t.unit);
            return (
              <span
                key={t.unit}
                title={t.unit}
                className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded border border-primary/25 bg-primary/[0.04] mono text-[11px] tabnum"
              >
                <span className="text-primary/90">{name || truncMid(t.unit, 6, 4)}</span>
                <span className="text-foreground/90 font-semibold">
                  {Number(t.quantity).toLocaleString("en-US")}
                </span>
              </span>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};
